/* ============================================
   BuddySIM Theme JS v2
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ---- Mobile Menu Toggle ---- */
  var toggle = document.getElementById('mobile-toggle');
  var nav = document.getElementById('main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function() {
      var isOpen = nav.classList.toggle('is-open');
      this.setAttribute('aria-expanded', isOpen);
    });

    document.addEventListener('click', function(e) {
      if (nav.classList.contains('is-open') && !nav.contains(e.target) && !toggle.contains(e.target)) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---- Country Search Filter ---- */
  var searchInputs = document.querySelectorAll('.country-grid__search');
  searchInputs.forEach(function(search) {
    search.addEventListener('input', function() {
      var q = this.value.toLowerCase();
      var grid = this.closest('.country-grid') || this.closest('section');
      if (!grid) return;
      var cards = grid.querySelectorAll('.country-card');
      cards.forEach(function(card) {
        var name = card.getAttribute('data-country-name') || '';
        if (!name) {
          var nameEl = card.querySelector('.country-card__name');
          name = nameEl ? nameEl.textContent.toLowerCase() : '';
        }
        card.style.display = name.includes(q) ? '' : 'none';
      });
    });
  });

  /* ---- Scroll Animations (IntersectionObserver) ---- */
  var animSelectors = [
    '.how-it-works__step',
    '.testimonial-card',
    '.faq-item',
    '.country-card',
    '.blog-card',
    '.app-teaser__inner',
    '.b2b-cta__inner'
  ];
  var animEls = document.querySelectorAll(animSelectors.join(','));
  if ('IntersectionObserver' in window && animEls.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animEls.forEach(function(el) {
      el.classList.add('animate-in');
      observer.observe(el);
    });
  }

  /* ---- Smooth Scroll for Anchor Links ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var targetId = this.getAttribute('href');
      if (targetId === '#') return;
      var target = document.querySelector(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (nav && nav.classList.contains('is-open')) {
          nav.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  });

  /* ---- Header Sticky Shadow on Scroll ---- */
  var header = document.querySelector('.header');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var scrollY = window.pageYOffset;
      if (scrollY > 10) {
        header.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
      } else {
        header.style.boxShadow = '';
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

});

/* ---- Animation CSS (injected) ---- */
(function() {
  var style = document.createElement('style');
  style.textContent = [
    '.animate-in{opacity:0;transform:translateY(20px);transition:opacity .5s ease,transform .5s ease}',
    '.animate-in.is-visible{opacity:1;transform:translateY(0)}',
    '@media(prefers-reduced-motion:reduce){.animate-in{opacity:1;transform:none;transition:none}}'
  ].join('');
  document.head.appendChild(style);
})();
